export function normalizeRoomId(value: string): string | null {
  const decoded = decodeURIComponent(value).trim().toUpperCase();
  const match = decoded.match(/\b([A-Z0-9]{1,8})[\s_-]+([A-Z0-9]{1,10})\b/);
  return match ? `${match[1]}-${match[2]}` : null;
}

export function normalizeRoomSearchText(value: string): string {
  return value.trim().toLowerCase().replace(/[\s_-]+/g, '');
}

export function roomIdToScheduleLabel(roomId: string): string {
  return roomId.replace('-', ' ');
}
